module.exports = __webpack_public_path__ + "img/horizontal_6_1_8003.f8e87717.png";